const initializeSimpleModal = () => {
    const simpleModals = $(".js-simple-modal");

    simpleModals.each((index, simpleModal) => {
        const backDrop    = $(simpleModal).find(".modal-container__backdrop");
        const closeButton = $(simpleModal).find(".js-close-button");

        backDrop.on("click", () => {
            $(simpleModal).remove();
        });

        closeButton.on("click", () => {
            $(simpleModal).remove();
        });
    });
};

export default initializeSimpleModal;
